import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {CoreDI, CoreSettingsParameters, DeviceType, IBrowser, inversifyContainer, Settings} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot';

export class AddDeviceRelatedClassesAct extends AsyncActDecorator {
    private _browser!: IBrowser;
    public async execute(): Promise<void> {
        const platform = (this.settings as Settings<SlotSettingsParameters & CoreSettingsParameters>).get('platform');
        const isDesktop = platform === DeviceType.DESKTOP;

        if (!isDesktop) {
            this.browser.disableDoubleTapToZoom();
        }

        this.addDeviceRelatedClasses(isDesktop);
    }

    private addDeviceRelatedClasses(isDesktop: boolean): void {
        if (isDesktop) {
            document.body.classList.add('desktop');
        } else {
            if (this.device.iOS) {
                document.body.classList.add('ios');
            }
        }
    }

    public get browser(): IBrowser {
        this._browser ??= inversifyContainer.get<IBrowser>(CoreDI.Browser);

        return this._browser;
    }

    getName(): string {
        return 'AddDeviceRelatedClassesAct';
    }
}